<template>
  <!-- fabric columns Modal -->
  <div
    class="modal fade"
    id="fabric-columns-modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="modelTitleId"
    aria-hidden="true"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Select Columns</h5>
        </div>
        <div class="modal-body">
          <div class="container-fluid">
            <div class="row">
              <div
                class="col-md-6"
                v-for="column in allColumnsToCompare"
                :key="column.key"
              >
                <p-check
                  :name="column.key"
                  :value="column.key"
                  color="success"
                  class="mb-10 p-default"
                  v-model="selectedColumns"
                >
                  {{ column.title }}
                </p-check>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">
            Close
          </button>
          <button type="button" class="btn btn-primary" @click="submit">
            Submit
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import fabricColumns from "../tools/fabricColumns";
export default {
  props: ["value"],
  data() {
    return {
      allColumnsToCompare: fabricColumns,
      selectedColumns: [],
    };
  },
  watch: {
    value: function () {
      this.selectedColumns = this.value;
    },
  },
  mounted() {
    this.selectedColumns = this.value;
  },
  methods: {
    submit() {
      this.$emit("submit", this.selectedColumns);
      hide_modal("#fabric-columns-modal");
    },
  },
};
</script>
